/**
 * Slider vantaggi prodotto.
 * Larghezza piena, card trascinabili (scroll nativo), solo pallini per paginazione.
 * Autoplay: passa alla slide successiva a intervalli fissi (es. ogni 10 s).
 */
(function () {
  var AUTOPLAY_INTERVAL_MS = 10000;

  document.querySelectorAll('.product-benefits-slider').forEach(function (section) {
    var track = section.querySelector('[data-benefits-track]');
    var dots = section.querySelectorAll('[data-benefits-dot]');
    var slides = section.querySelectorAll('[data-benefits-slide]');

    if (!track || slides.length <= 1) return;

    var intervalMs = parseInt(section.dataset.autoplayInterval, 10);
    if (!intervalMs || intervalMs < 1000) intervalMs = AUTOPLAY_INTERVAL_MS;

    var currentIndex = 0;
    var autoplayTimer = null;

    function getScrollPositionForIndex(index) {
      var slide = slides[0];
      if (!slide) return 0;
      return index * slide.offsetWidth;
    }

    function getIndexFromScrollLeft() {
      var slide = slides[0];
      if (!slide) return 0;
      var w = slide.offsetWidth;
      if (w <= 0) return 0;
      var index = Math.round(track.scrollLeft / w);
      if (index < 0) index = 0;
      if (index >= slides.length) index = slides.length - 1;
      return index;
    }

    function updateDots() {
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === currentIndex);
      }
    }

    function goToSlide(index) {
      var n = slides.length;
      if (n === 0) return;
      if (index < 0) index = 0;
      if (index >= n) index = n - 1;
      currentIndex = index;

      track.scrollLeft = getScrollPositionForIndex(currentIndex);
      updateDots();
    }

    function next() {
      var n = slides.length;
      if (n <= 1) return;
      var nextIndex = currentIndex + 1;
      if (nextIndex >= n) nextIndex = 0;
      goToSlide(nextIndex);
    }

    function startAutoplay() {
      stopAutoplay();
      autoplayTimer = setInterval(next, intervalMs);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    track.addEventListener('scroll', function () {
      var i = getIndexFromScrollLeft();
      if (i !== currentIndex) {
        currentIndex = i;
        updateDots();
      }
    });

    /* Trascinamento con mouse */
    var dragging = false;
    var startX;
    var startScrollLeft;

    function onMouseMove(e) {
      if (!dragging) return;
      var dx = startX - e.pageX;
      track.scrollLeft = startScrollLeft + dx;
    }

    function onMouseUp() {
      if (!dragging) return;
      dragging = false;
      track.style.scrollBehavior = '';
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    }

    track.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      dragging = true;
      startX = e.pageX;
      startScrollLeft = track.scrollLeft;
      track.style.scrollBehavior = 'auto';
      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
      e.preventDefault();
    });

    /* Trascinamento touch (mobile) */
    var touchStartX;
    var touchStartScrollLeft;

    track.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      touchStartX = e.touches[0].pageX;
      touchStartScrollLeft = track.scrollLeft;
    }, { passive: true });

    track.addEventListener('touchmove', function (e) {
      if (e.touches.length !== 1) return;
      var x = e.touches[0].pageX;
      track.scrollLeft = touchStartScrollLeft + (touchStartX - x);
    }, { passive: true });

    for (var d = 0; d < dots.length; d++) {
      (function (idx) {
        dots[idx].addEventListener('click', function () { goToSlide(idx); startAutoplay(); });
      })(d);
    }

    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);

    goToSlide(0);
    startAutoplay();
  });
})();
